var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('loader',{attrs:{"loading":_vm.loading}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"designer-content"},[_c('span',{domProps:{"innerHTML":_vm._s(this.iframeUrl)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }